function findMembershipProduct() {
  const textToFind = "membership";
  const rows = $("table.cart-items .cart-item");
  let foundElement = null;

  rows.find(".cart-title").each(function () {
    if ($(this).text().toLowerCase().includes(textToFind)) {
      foundElement = $(this);
    }
  });

  if (!foundElement) return null;

  return foundElement.closest(".cart-item");
}

$(document).ready(function () {
  $(".cart-item-remove").on("click", function () {
    const foundElement = findMembershipProduct();

    if (foundElement) {
      fetch(window.Shopify.routes.root + "cart/clear.js", {
        method: "POST",
      }).then(() => (window.location.href = "/cart"));
    }
  });

  const form = document.getElementById("cc-modal-add-more-form");
  if(form){
    const submitButton = document.getElementById(
      "cc-modal-add-more-submit-button"
    );
  
    form.addEventListener("submit", function (event) {
      submitButton.disabled = true;
    });
  }

  $('.icon-minus').on('click', function() {
    const quantity = parseInt($('input#quantity').val());
    if(quantity === 1) return;
    $('input#quantity').val(quantity - 1);
  })
  $('.icon-plus').on('click', function() {
    const quantity = parseInt($('input#quantity').val());
    if(quantity === 5) return;
    $('input#quantity').val(quantity + 1);
  })
});
